// extracted by mini-css-extract-plugin
export default {"title":"styles_title__-zgZm"};